// countryApi.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Countries } from "model/countries-model";
import { ApiResponse } from "model/response-model";
import { baseQueryWithReauth } from "./config/interceptor";

export const countryApi = createApi({
  reducerPath: "countryApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getCountries: builder.query<ApiResponse<Countries[]>, void>({
      query: () => "Countries",
    }),
  }),
});

export const { useGetCountriesQuery } = countryApi;
